<template>
    <div style="background: #faf9f9">
        <div class="page-wrap">
            <h1 class="topTip">精品推荐</h1>
            <section>
                <div class="header-wrap">
                    <div class="card-wrap wrapScroll">
                        <swiper
                            :slides-per-view="3"
                            :space-between="50"
                            autoplay
                            @swiper="onSwiper"
                           
                            @slideChange="onSlideChange"
                            class="swiperCard"
                            :navigation="{nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}"
                        >
                            <swiper-slide
                                v-for="(item, index) in RoadsRecommendList"
                                :key="item"
                            >
                                <div class="swiper-img-wrap card">
                                    <router-link
                                        :to="
                                            '/detailPc?type=Roads&id=' +
                                            item._id
                                        "
                                    >
                                        <img
                                            :src="
                                                RoadsImagesList[index]
                                                    .tempFileURL
                                            "
                                            alt=""
                                        />
                                        <div class="card-info">
                                            <div class="card-title">
                                                {{ item.Name }}
                                            </div>
                                            <div
                                                class="card-tags-wrap"
                                                v-html="getAges(item)"
                                            ></div>
                                        </div>
                                    </router-link>
                                </div>
                            </swiper-slide>
                            <swiper-slide
                                v-for="(item, index) in CourseRecommendList"
                                :key="item"
                            >
                                <div class="swiper-img-wrap card">
                                    <router-link
                                        :to="
                                            '/detailPc?type=Course&id=' +
                                            item._id
                                        "
                                    >
                                        <img
                                            :src="
                                                CourseImagesList[index]
                                                    .tempFileURL
                                            "
                                            alt=""
                                        />
                                        <div class="card-info">
                                            <div class="card-title">
                                                {{ item.Name }}
                                            </div>
                                            <div
                                                class="card-tags-wrap"
                                                v-html="getAges(item)"
                                            ></div>
                                        </div>
                                    </router-link>
                                </div>
                            </swiper-slide>
                            <div class="swiper-button-next rightBtn cutBtn"></div>
                            <div class="swiper-button-prev leftBtn cutBtn"></div>  
                        </swiper>
                       
                    </div>

                </div>
            </section>

            <!-- 历史类 -->
            <div></div>
            <h1 class="topTip">分类推荐</h1>
            <section v-show="HistoryClassList.length">
                <div class="section-header">
                    <div class="section-header-title">历史类<i></i></div>
                    <div class="more">
                        <router-link to="/listPc?type=1">查看更多</router-link>
                    </div>
                </div>
                <div class="section-content">
                    <div
                        class="section-img-wrap"
                        v-for="item in HistoryClassList.slice(0,4)"
                        :key="item._id"
                    >
                        <router-link
                            :to="
                                '/detailPc?type=' +
                                item.slefType +
                                '&id=' +
                                item._id
                            "
                        >
                            <div class="img-wrap">
                                <img :src="item.tempFileURL" alt="" />
                            </div>
                            <div class="section-info">
                                <div class="section-title">{{ item.Name }}</div>
                                <div class="section-desc">{{ item.Owner }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>
            <!-- 红色类 -->
            <section v-show="RedClassList.length">
                <div class="section-header">
                    <div class="section-header-title">红色类<i></i></div>
                    <div class="more">
                        <router-link to="/listPc?type=2">查看更多</router-link>
                    </div>
                </div>
                <div class="section-content">
                    <div
                        class="section-img-wrap"
                        v-for="item in RedClassList"
                        :key="item._id"
                    >
                        <router-link
                            :to="
                                '/detailPc?type=' +
                                item.slefType +
                                '&id=' +
                                item._id
                            "
                        >
                            <div class="img-wrap">
                                <img :src="item.tempFileURL" alt="" />
                            </div>
                            <div class="section-info">
                                <div class="section-title">{{ item.Name }}</div>
                                <div class="section-desc">{{ item.Owner }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>
            <!-- 艺术类 -->
            <section v-show="ArtClassList.length">
                <div class="section-header">
                    <div class="section-header-title">艺术类<i></i></div>
                    <div class="more">
                        <router-link to="/listPc?type=3">查看更多</router-link>
                    </div>
                </div>
                <div class="section-content">
                    <div
                        class="section-img-wrap"
                        v-for="item in ArtClassList"
                        :key="item._id"
                    >
                        <router-link
                            :to="
                                '/detailPc?type=' +
                                item.slefType +
                                '&id=' +
                                item._id
                            "
                        >
                            <div class="img-wrap">
                                <img :src="item.tempFileURL" alt="" />
                            </div>
                            <div class="section-info">
                                <div class="section-title">{{ item.Name }}</div>
                                <div class="section-desc">{{ item.Owner }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>
            <!-- 自然类 -->
            <section v-show="NatureClassList.length">
                <div class="section-header">
                    <div class="section-header-title">自然类<i></i></div>
                    <div class="more">
                        <router-link to="/listPc?type=4">查看更多</router-link>
                    </div>
                </div>
                <div class="section-content">
                    <div
                        class="section-img-wrap"
                        v-for="item in NatureClassList"
                        :key="item._id"
                    >
                        <router-link
                            :to="
                                '/detailPc?type=' +
                                item.slefType +
                                '&id=' +
                                item._id
                            "
                        >
                            <div class="img-wrap">
                                <img :src="item.tempFileURL" alt="" />
                            </div>
                            <div class="section-info">
                                <div class="section-title">{{ item.Name }}</div>
                                <div class="section-desc">{{ item.Owner }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>
            <!-- 民族民俗类 -->
            <section v-show="NationClassList.length">
                <div class="section-header">
                    <div class="section-header-title">民族民俗类<i></i></div>
                    <div class="more">
                        <router-link to="/listPc?type=5">查看更多</router-link>
                    </div>
                </div>
                <div class="section-content">
                    <div
                        class="section-img-wrap"
                        v-for="item in NationClassList"
                        :key="item._id"
                    >
                        <router-link
                            :to="
                                '/detailPc?type=' +
                                item.slefType +
                                '&id=' +
                                item._id
                            "
                        >
                            <div class="img-wrap">
                                <img :src="item.tempFileURL" alt="" />
                            </div>
                            <div class="section-info">
                                <div class="section-title">{{ item.Name }}</div>
                                <div class="section-desc">{{ item.Owner }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>
            <!-- 科技类 -->
            <section v-show="ScienceClassList.length">
                <div class="section-header">
                    <div class="section-header-title">科技类<i></i></div>
                    <div class="more">
                        <router-link to="/listPc?type=6">查看更多</router-link>
                    </div>
                </div>
                <div class="section-content">
                    <div
                        class="section-img-wrap"
                        v-for="item in ScienceClassList"
                        :key="item._id"
                    >
                        <router-link
                            :to="
                                '/detailPc?type=' +
                                item.slefType +
                                '&id=' +
                                item._id
                            "
                        >
                            <div class="img-wrap">
                                <img :src="item.tempFileURL" alt="" />
                            </div>
                            <div class="section-info">
                                <div class="section-title">{{ item.Name }}</div>
                                <div class="section-desc">{{ item.Owner }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>
        </div>
        <footer-pc></footer-pc>
    </div>
</template>

<script>
import FooterPc from "../components/FooterPc";
import { getImgToCloud, getIndexInfoList } from "../util/util";
import SwiperCore, { Pagination, Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
SwiperCore.use([Autoplay, Pagination, Navigation]);

export default {
    components: {
        FooterPc,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            RoadsRecommendList: [],
            CourseRecommendList: [],
            RoadsImagesList: [],
            CourseImagesList: [],
            HistoryClassList: [], // 历史类
            RedClassList: [], //红色类
            ArtClassList: [], //艺术类
            NatureClassList: [], //自然类
            NationClassList: [], //民族民俗类
            ScienceClassList: [], //科技类
            flag: true
        };
    },
    beforeCreate() {
        // 登录成功
    },
    created() {
        this.getRoadsRecommend();
        this.getCourseRecommend();
        this.getListInfo();
    },
    mounted() {},
    methods: {
        onSwiper(swiper) {
            console.log(swiper);
        },
        onSlideChange() {
            // console.log("slide change");
        },
        getAges(item) {
            let str = `<span class="card-tag">${
                item.slefType == "Roads" ? "线路" : "课程"
            }</span><span class="card-tag">${item.Class}</span>`;
            item.Age.split(",").map((age) => {
                str += `<span class="card-tag">${age}</span>`;
            });
            return str;
        },
        // 获取所有路线
        getAllRoads(params = {}) {
            const db = this.$TCB_App.database();
            const AllRoads = db.collection("DataBase_All_Roads");
            return AllRoads.orderBy("EditDate", "desc").where(params).get();
        },
        // 获取推荐路线
        getRoadsRecommend() {
            const db = this.$TCB_App.database();
            const RoadsRecommend = db.collection("DataBase_Roads_Recommend");
            const _ = db.command;
            RoadsRecommend.get()
                .then((res) => {
                    const list = res.data.map((item) => {
                        return item.Road_ID;
                    });
                    this.getAllRoads({
                        _id: _.in(list),
                    })
                        .then((res) => {
                            // console.log(res.data);
                            const ids = res.data.map((item) => {
                                return item._id;
                            });
                            if (ids.length > 0) {
                                getImgToCloud({
                                    name: "Roads",
                                    ids: ids,
                                }).then((data) => {
                                    // console.log(data.fileList);
                                    this.RoadsImagesList = this.RoadsImagesList.concat(
                                        data.fileList
                                    );
                                    this.RoadsRecommendList = this.RoadsRecommendList.concat(
                                        res.data
                                    );
                                });
                            } else {
                                this.RoadsRecommendList = this.RoadsRecommendList.concat(
                                    res.data
                                );
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        // 获取所有课程
        getAllCourse(params = {}) {
            const db = this.$TCB_App.database();
            const AllCourse = db.collection("DataBase_All_Course");
            return AllCourse.orderBy("EditDate", "desc").where(params).get();
        },
        // 获取推荐课程
        getCourseRecommend() {
            const db = this.$TCB_App.database();
            const CourseRecommend = db.collection("DataBase_Course_Recommend");
            const _ = db.command;
            CourseRecommend.get()
                .then((res) => {
                    const list = res.data.map((item) => {
                        return item.Course_ID;
                    });
                    this.getAllCourse({
                        _id: _.in(list),
                    })
                        .then((res) => {
                            // console.log(res.data);
                            const ids = res.data.map((item) => {
                                return item._id;
                            });
                            if (ids.length > 0) {
                                getImgToCloud({
                                    name: "Course",
                                    ids: ids,
                                }).then((data) => {
                                    // console.log(data.fileList);
                                    this.CourseImagesList = this.CourseImagesList.concat(
                                        data.fileList
                                    );
                                    this.CourseRecommendList = this.CourseRecommendList.concat(
                                        res.data
                                    );
                                });
                            } else {
                                this.CourseRecommendList = this.CourseRecommendList.concat(
                                    res.data
                                );
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getListInfo() {
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                where: {
                    Class: "历史类",
                },
                limit: 4,
            }).then((res) => {
                // console.log(res);
                this.HistoryClassList = this.HistoryClassList.concat(
                    res.flat(Infinity)
                );
            });
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                where: {
                    Class: "红色类",
                },
                limit: 4,
            }).then((res) => {
                // console.log(res);
                this.RedClassList = this.RedClassList.concat(
                    res.flat(Infinity)
                );
            });
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                where: {
                    Class: "艺术类",
                },
                limit: 4,
            }).then((res) => {
                // console.log(res);
                this.ArtClassList = this.ArtClassList.concat(
                    res.flat(Infinity)
                );
            });
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                where: {
                    Class: "自然类",
                },
                limit: 4,
            }).then((res) => {
                // console.log(res);
                this.NatureClassList = this.NatureClassList.concat(
                    res.flat(Infinity)
                );
            });
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                where: {
                    Class: "民族民俗类",
                },
                limit: 4,
            }).then((res) => {
                // console.log(res);
                this.NationClassList = this.NationClassList.concat(
                    res.flat(Infinity)
                );
            });
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                where: {
                    Class: "科技类",
                },
                limit: 4,
            }).then((res) => {
                console.log("科技类", res);
                this.ScienceClassList = this.ScienceClassList.concat(
                    res.flat(Infinity)
                );
            });
        },
    },
};
</script>

<style scoped lang="scss">
.swiperCard {
    .swiper-wrapper {
        height: 407px;
        .swiper-slide {
            margin-right: 23px !important;
            width: 350px !important;
            &:last-child{
                margin-right: 0!important;
            }
        }
    }
    .swiper-img-wrap {
        width: 100%;
        height: 407px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            max-height: 100%;
            max-width: 100%;
        }
    }
}

.page-wrap {
    background: #faf9f9;
    padding: 30px 20% 0;
}
.header-wrap {
    width: calc(100% - 40px);
    height: 407px;
    overflow: hidden;
    padding: 20px;
    position: relative;
    .cutBtn {
        position: absolute;
        width: 50px;
        height: 50px;
        top: calc((100% - 50px) / 2);
        background: cyan;
        cursor: pointer;
        border-radius: 50%;
        z-index: 99;
    }
    .leftBtn {
        left: 18px;
        background: url(../assets/left.png) no-repeat center center;
        background-size: contain;
        &:hover {
            background: url(../assets/left_a.png) no-repeat center center;
            background-size: contain;
        }
    }
    .rightBtn {
        right: 18px;
        background: url(../assets/right.png) no-repeat center center;
        background-size: contain;
        &:hover {
            background: url(../assets/right_a.png) no-repeat center center;
            background-size: contain;
        }
    }
}

.header-wrap .card-wrap {
    height: 100%;
    width: 100%;
    position: relative;
    font-size: 0;
    display: inline-flex;
    .card {
        height: 100%;
        width: 350px;
        margin-right: 23px;
        background: #ccc;
        position: relative;
        border-radius: 4px;
        > a {
            display: flex;
            justify-content: center;
            align-items: center;
            /* width: 100%; */
            height: 100%;
        }
        // &:nth-child(3n){
        //     margin-right: 0;
        // }
    }
    img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px 4px 0 0;
    }
    .card-info {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        color: #ffffff;
        padding: 0 20px 8px;
        width: calc(100% - 40px);
        background-image: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6) 100%
        );
        border-radius: 0 0 4px 4px;
        .card-title {
            text-align: left;
            font-size: 16px;
            color: #ffffff;
            line-height: 16px;
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
            margin: 32px 0 10px;
        }
        .card-tags-wrap {
            font-size: 0;
            span:nth-child(4n+1) {
                background: #7cb6f3;
            }
            span:nth-child(4n+2) {
                background: #e8b585;
            }
            span:nth-child(4n+3) {
                background: #95a7ff;
            }
            span:nth-child(4n+4) {
                background: #85e8a0;
            }
        }
        .card-tag {
            display: inline-block;
            font-size: 12px;
            padding: 4px 8px;
            border-radius: 2.67px;
            margin-right: 10px;
        }
    }
}
.topTip {
    font-size: 24px;
    font-weight: bold;
    color: #111111;
    line-height: 1;
    position: relative;
    padding-left: 10px;
    &::before {
        content: "";
        position: absolute;
        display: inline-block;
        height: 100%;
        width: 4px;
        background: #92bc10;
        left: 0;
        top: 0;
    }
}
section {
    margin-top: 20px;
    background: #ffffff;
    border: 1px solid #e7edf6;
    box-shadow: 0 6px 14px 0 rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    .section-header {
        width: calc(100% - 40px);
        height: 58px;
        line-height: 58px;
        border-bottom: solid 0.133vw #eee;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .section-header-title {
            font-size: 22px;
            font-weight: bold;
            color: #111111;
            position: relative;
            i {
                display: inline-block;
                width: 75%;
                height: 2px;
                position: absolute;
                bottom: -2px;
                right: 0;
                background: #71a209;
            }
            // &::before {
            //   content: "";
            //   position: absolute;
            //   display: inline-block;
            //   height: 100%;
            //   width: 6px;
            //   background: #92bc10;
            //   left: 0;
            //   top: 0;
            // }
        }
        .more {
            font-size: 12px;
        }
        .more a {
            color: #71a209;
            text-decoration: none;
        }
    }
    .section-content {
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    .section-img-wrap {
        // height: 330px;
        overflow: hidden;
        position: relative;
        font-size: 0;
        margin-right: 20px;
        width: calc((100% - 60px) / 4);
        &:nth-child(4n) {
            margin-right: 0;
        }
        .img-wrap {
            width: 254px;
            height: 254px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f5f5f5;
            img {
                display: inline-block;
                max-width: 100%;
                max-height: 100%;
            }
        }
        a {
            color: #111;
            text-decoration: none;
        }
    }
    .section-info {
        width: 100%;
        box-sizing: border-box;
        /* position: absolute;
    bottom: 0;
    left: 0; */
        .section-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 16px;
            color: #12263f;
            line-height: 30px;
        }
        .section-desc {
            font-size: 14px;
            color: #7288a6;
        }
    }
}
</style>
<style lang='scss'>
.header-wrap .card-wrap {
    height: 100%;
    position: relative;
    font-size: 0;
    display: inline-flex;
    .card {
        height: 100%;
        width: 350px;
        margin-right: 23px;
        background: #ccc;
        position: relative;
        border-radius: 4px;
        > a {
            display: flex;
            justify-content: center;
            align-items: center;
            /* width: 100%; */
            height: 100%;
        }
        // &:nth-child(3n){
        //     margin-right: 0;
        // }
    }
    img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px 4px 0 0;
    }
    .card-info {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        color: #ffffff;
        padding: 0 20px 8px;
        width: calc(100% - 40px);
        background-image: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6) 100%
        );
        border-radius: 0 0 4px 4px;
        .card-title {
            text-align: left;
            font-size: 16px;
            color: #ffffff;
            line-height: 16px;
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
            margin: 32px 0 10px;
        }
        .card-tags-wrap {
            font-size: 0;
             span:nth-child(4n+1) {
                background: #7cb6f3;
            }
            span:nth-child(4n+2) {
                background: #e8b585;
            }
            span:nth-child(4n+3) {
                background: #95a7ff;
            }
            span:nth-child(4n+4) {
                background: #85e8a0;
            }
        }
        .card-tag {
            display: inline-block;
            font-size: 12px;
            padding: 4px 8px;
            border-radius: 2.67px;
            margin-right: 10px;
        }
    }
}
</style>